import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "sidebar-menu" }
const _hoisted_4 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_5 = {
  key: 0,
  class: "sidebar-nav-item"
}
const _hoisted_6 = {
  key: 1,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_7 = {
  id: "sidebarCollapseColis",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_8 = { class: "accordion-body" }
const _hoisted_9 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_10 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_11 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_12 = {
  key: 2,
  class: "sidebar-sub-menu-item"
}
const _hoisted_13 = {
  key: 2,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_14 = {
  id: "sidebarCollapseStock",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_15 = { class: "accordion-body" }
const _hoisted_16 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_17 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_18 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_19 = {
  key: 3,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_20 = {
  id: "sidebarCollapseBl",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_21 = { class: "accordion-body" }
const _hoisted_22 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_23 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_24 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_25 = {
  key: 4,
  class: "sidebar-nav-item"
}
const _hoisted_26 = {
  key: 5,
  class: "sidebar-nav-item"
}
const _hoisted_27 = {
  key: 6,
  class: "sidebar-nav-item"
}
const _hoisted_28 = {
  key: 7,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_29 = {
  id: "sidebarCollapsePayments",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_30 = { class: "accordion-body" }
const _hoisted_31 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_32 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_33 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_34 = {
  key: 8,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_35 = {
  id: "sidebarCollapseReturn",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_36 = { class: "accordion-body" }
const _hoisted_37 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_38 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_39 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_40 = {
  key: 9,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_41 = {
  id: "sidebarCollapseinvoices",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_42 = { class: "accordion-body" }
const _hoisted_43 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_44 = { class: "sidebar-sub-menu-item" }
const _hoisted_45 = { class: "sidebar-sub-menu-item" }
const _hoisted_46 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_47 = {
  key: 10,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_48 = {
  id: "sidebarCollapseCusts",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_49 = { class: "accordion-body" }
const _hoisted_50 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_51 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_52 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_53 = {
  key: 2,
  class: "sidebar-sub-menu-item"
}
const _hoisted_54 = {
  key: 11,
  class: "sidebar-nav-item"
}
const _hoisted_55 = {
  key: 12,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_56 = {
  id: "sidebarCollapsePickup",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_57 = { class: "accordion-body" }
const _hoisted_58 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_59 = { class: "sidebar-sub-menu-item" }
const _hoisted_60 = { class: "sidebar-sub-menu-item" }
const _hoisted_61 = {
  key: 13,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_62 = {
  id: "sidebarCollapseEleven",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_63 = { class: "accordion-body" }
const _hoisted_64 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_65 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_66 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_67 = {
  key: 14,
  class: "sidebar-nav-item"
}
const _hoisted_68 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_69 = {
  id: "sidebarCollapseTwentyTwo",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_70 = { class: "accordion-body" }
const _hoisted_71 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_72 = { class: "sidebar-sub-menu-item" }
const _hoisted_73 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_74 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_75 = {
  key: 2,
  class: "sidebar-sub-menu-item"
}
const _hoisted_76 = {
  key: 3,
  class: "sidebar-sub-menu-item"
}
const _hoisted_77 = {
  key: 4,
  class: "sidebar-sub-menu-item"
}
const _hoisted_78 = {
  key: 5,
  class: "sidebar-sub-menu-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _ctx.stateStoreInstance.open },
    ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-flex align-items-center text-white text-decoration-none"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.settingsStore.logo || require('../../assets/images/logo.png'),
            alt: "logo-icon",
            style: {"width":"80%","max-height":"44px","object-fit":"fill"}
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "border-bottom" }, null, -1)),
      _createElementVNode("button", {
        class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1)
      ]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_ctx.auth.can('HOME_PAGE'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "flaticon-more-1" }, null, -1),
                  _createElementVNode("span", { class: "title" }, "Dashboard", -1)
                ])),
                _: 1,
                __: [3]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.auth.can('PARCELS'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
              _cache[7] || (_cache[7] = _createElementVNode("a", {
                href: "#",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#sidebarCollapseColis",
                "aria-expanded": "false",
                "aria-controls": "sidebarCollapseColis"
              }, [
                _createElementVNode("i", { class: "flaticon-sterile-box" }),
                _createElementVNode("span", { class: "title" }, "Colis")
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("ul", _hoisted_9, [
                    (_ctx.auth.can('PARCELS'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                          _createVNode(_component_router_link, {
                            to: "/colis-list",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode(" Liste des colis ", -1)
                            ])),
                            _: 1,
                            __: [4]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.auth.can('PARCELS'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                          _createVNode(_component_router_link, {
                            to: "/new-colis-list",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode(" Nouveaux colis ", -1)
                            ])),
                            _: 1,
                            __: [5]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.auth.can('PARCELS'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                          _createVNode(_component_router_link, {
                            to: "/add-colis",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createTextVNode(" Nouveau Colis ", -1)
                            ])),
                            _: 1,
                            __: [6]
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.auth.can('STOCK'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
              _cache[10] || (_cache[10] = _createElementVNode("a", {
                href: "#",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#sidebarCollapseStock",
                "aria-expanded": "false",
                "aria-controls": "sidebarCollapseStock"
              }, [
                _createElementVNode("i", { class: "flaticon-sterile-box" }),
                _createElementVNode("span", { class: "title" }, "Inventaire")
              ], -1)),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("ul", _hoisted_16, [
                    (_ctx.auth.can('STOCK'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                          _createVNode(_component_router_link, {
                            to: "/products-list",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                              _createTextVNode(" Liste des produits ", -1)
                            ])),
                            _: 1,
                            __: [8]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.auth.can('STOCK') && _ctx.auth.can('PARCELS'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                          _createVNode(_component_router_link, {
                            to: "/colis-stock-list",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createTextVNode(" Colis de stock ", -1)
                            ])),
                            _: 1,
                            __: [9]
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.auth.can('BL') || _ctx.auth.can('BL_S'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
              _cache[13] || (_cache[13] = _createElementVNode("a", {
                href: "#",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#sidebarCollapseBl",
                "aria-expanded": "false",
                "aria-controls": "sidebarCollapseBl"
              }, [
                _createElementVNode("i", { class: "flaticon-document" }),
                _createElementVNode("span", { class: "title" }, "Bons de livraison")
              ], -1)),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("ul", _hoisted_22, [
                    (_ctx.auth.can('BL'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                          _createVNode(_component_router_link, {
                            to: "/delivery-notes",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode(" Bons de livraison ", -1)
                            ])),
                            _: 1,
                            __: [11]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.auth.can('BL_S'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                          _createVNode(_component_router_link, {
                            to: "/delivery-stock-notes",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode(" Bons de livraison stock ", -1)
                            ])),
                            _: 1,
                            __: [12]
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.auth.can('RECEPTION'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
              _createVNode(_component_router_link, {
                to: "/reception-notes",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createElementVNode("i", { class: "flaticon-draft" }, null, -1),
                  _createElementVNode("span", { class: "title" }, "Réception Colis", -1)
                ])),
                _: 1,
                __: [14]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.auth.can('BE'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
              _createVNode(_component_router_link, {
                to: "/sent-notes",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createElementVNode("i", { class: "flaticon-telegram" }, null, -1),
                  _createElementVNode("span", { class: "title" }, "Bons d'envoi", -1)
                ])),
                _: 1,
                __: [15]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.auth.can('BDIS'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
              _createVNode(_component_router_link, {
                to: "/distribution-notes",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createElementVNode("i", { class: "flaticon-cube-3d" }, null, -1),
                  _createElementVNode("span", { class: "title" }, "Bons distribution", -1)
                ])),
                _: 1,
                __: [16]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.auth.can('BP_L') || _ctx.auth.can('BP_Z'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
              _cache[19] || (_cache[19] = _createElementVNode("a", {
                href: "#",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#sidebarCollapsePayments",
                "aria-expanded": "false",
                "aria-controls": "sidebarCollapsePayments"
              }, [
                _createElementVNode("i", { class: "flaticon-fast-delivery" }),
                _createElementVNode("span", { class: "title" }, "Factures Livreurs")
              ], -1)),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("ul", _hoisted_31, [
                    (_ctx.auth.can('BP_L'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                          _createVNode(_component_router_link, {
                            to: "/payment-note-liste",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createTextVNode(" Factures livreurs ", -1)
                            ])),
                            _: 1,
                            __: [17]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.auth.can('BP_Z'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                          _createVNode(_component_router_link, {
                            to: "/payment-zone-liste",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                              _createTextVNode(" Factures Zones ", -1)
                            ])),
                            _: 1,
                            __: [18]
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.auth.can('BR_Z') || _ctx.auth.can('BR_C'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
              _cache[22] || (_cache[22] = _createElementVNode("a", {
                href: "#",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#sidebarCollapseReturn",
                "aria-expanded": "false",
                "aria-controls": "sidebarCollapseReturn"
              }, [
                _createElementVNode("i", { class: "flaticon-project" }),
                _createElementVNode("span", { class: "title" }, "Bons de retour")
              ], -1)),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("ul", _hoisted_37, [
                    (_ctx.auth.can('BR_Z'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                          _createVNode(_component_router_link, {
                            to: "/return-zone-liste",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[20] || (_cache[20] = [
                              _createTextVNode(" Retours zones ", -1)
                            ])),
                            _: 1,
                            __: [20]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.auth.can('BR_C'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                          _createVNode(_component_router_link, {
                            to: "/return-client-liste",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[21] || (_cache[21] = [
                              _createTextVNode(" Retours clients ", -1)
                            ])),
                            _: 1,
                            __: [21]
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.auth.can('INV'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_40, [
              _cache[26] || (_cache[26] = _createElementVNode("a", {
                href: "#",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#sidebarCollapseinvoices",
                "aria-expanded": "false",
                "aria-controls": "sidebarCollapseinvoices"
              }, [
                _createElementVNode("i", { class: "flaticon-money" }),
                _createElementVNode("span", { class: "title" }, "Factures Client")
              ], -1)),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("ul", _hoisted_43, [
                    _createElementVNode("li", _hoisted_44, [
                      _createVNode(_component_router_link, {
                        to: "/invoices-liste",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                          _createTextVNode(" Liste des factures ", -1)
                        ])),
                        _: 1,
                        __: [23]
                      })
                    ]),
                    _createElementVNode("li", _hoisted_45, [
                      _createVNode(_component_router_link, {
                        to: "/add-invoices",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => _cache[24] || (_cache[24] = [
                          _createTextVNode(" Nouvelle Facture ", -1)
                        ])),
                        _: 1,
                        __: [24]
                      })
                    ]),
                    (_ctx.auth.can('VIREMENT'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_46, [
                          _createVNode(_component_router_link, {
                            to: "/virements-liste",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                              _createTextVNode(" Virements ", -1)
                            ])),
                            _: 1,
                            __: [25]
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.auth.can('CUSTOMERS') || _ctx.auth.can('NEW_CUSTOMERS'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
              _cache[30] || (_cache[30] = _createElementVNode("a", {
                href: "#",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#sidebarCollapseCusts",
                "aria-expanded": "false",
                "aria-controls": "sidebarCollapseCusts"
              }, [
                _createElementVNode("i", { class: "flaticon-users-group" }),
                _createElementVNode("span", { class: "title" }, "Clients")
              ], -1)),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("ul", _hoisted_50, [
                    (_ctx.auth.can('CUSTOMERS'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                          _createVNode(_component_router_link, {
                            to: "/customers-list",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[27] || (_cache[27] = [
                              _createTextVNode(" Liste des clients ", -1)
                            ])),
                            _: 1,
                            __: [27]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.auth.can('NEW_CUSTOMERS'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_52, [
                          _createVNode(_component_router_link, {
                            to: "/new-customers-list",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                              _createTextVNode(" Nouveaux Clients ", -1)
                            ])),
                            _: 1,
                            __: [28]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.auth.can('CUSTOMERS'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_53, [
                          _createVNode(_component_router_link, {
                            to: "/verifications",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[29] || (_cache[29] = [
                              _createTextVNode(" Centre de vérification ", -1)
                            ])),
                            _: 1,
                            __: [29]
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.auth.can('CLAIM'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_54, [
              _createVNode(_component_router_link, {
                to: "/claims-list",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => _cache[31] || (_cache[31] = [
                  _createElementVNode("i", { class: "flaticon-warning" }, null, -1),
                  _createElementVNode("span", { class: "title" }, "Réclamations", -1)
                ])),
                _: 1,
                __: [31]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.auth.can('PICK_UP'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_55, [
              _cache[34] || (_cache[34] = _createElementVNode("a", {
                href: "#",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#sidebarCollapsePickup",
                "aria-expanded": "false",
                "aria-controls": "sidebarCollapsePickup"
              }, [
                _createElementVNode("i", { class: "flaticon-layer-2" }),
                _createElementVNode("span", { class: "title" }, "Ramassage")
              ], -1)),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("ul", _hoisted_58, [
                    _createElementVNode("li", _hoisted_59, [
                      _createVNode(_component_router_link, {
                        to: "/pickup-list",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => _cache[32] || (_cache[32] = [
                          _createTextVNode(" Bon de ramassage ", -1)
                        ])),
                        _: 1,
                        __: [32]
                      })
                    ]),
                    _createElementVNode("li", _hoisted_60, [
                      _createVNode(_component_router_link, {
                        to: "/requests-pickup-list",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                          _createTextVNode(" Demandes de ramassages ", -1)
                        ])),
                        _: 1,
                        __: [33]
                      })
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.auth.can('USERS') || _ctx.auth.can('NEW_LIVREUR'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_61, [
              _cache[37] || (_cache[37] = _createElementVNode("a", {
                href: "#",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#sidebarCollapseEleven",
                "aria-expanded": "false",
                "aria-controls": "sidebarCollapseEleven"
              }, [
                _createElementVNode("i", { class: "flaticon-user-3" }),
                _createElementVNode("span", { class: "title" }, "Utilisateurs")
              ], -1)),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("ul", _hoisted_64, [
                    (_ctx.auth.can('USERS'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_65, [
                          _createVNode(_component_router_link, {
                            to: "/users-list",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[35] || (_cache[35] = [
                              _createTextVNode(" Liste des utilisateurs ", -1)
                            ])),
                            _: 1,
                            __: [35]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.auth.can('NEW_LIVREUR'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_66, [
                          _createVNode(_component_router_link, {
                            to: "/new-driver-list",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[36] || (_cache[36] = [
                              _createTextVNode(" Nouveaux livreurs ", -1)
                            ])),
                            _: 1,
                            __: [36]
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.auth.can('SETTINGS'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_67, [
              _createVNode(_component_router_link, {
                to: "/spents",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => _cache[38] || (_cache[38] = [
                  _createElementVNode("i", { class: "flaticon-warning" }, null, -1),
                  _createElementVNode("span", { class: "title" }, "Les dépenses", -1)
                ])),
                _: 1,
                __: [38]
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_68, [
          _cache[46] || (_cache[46] = _createElementVNode("a", {
            href: "#",
            class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
            "data-bs-toggle": "collapse",
            "data-bs-target": "#sidebarCollapseTwentyTwo",
            "aria-expanded": "false",
            "aria-controls": "sidebarCollapseTwentyTwo"
          }, [
            _createElementVNode("i", { class: "flaticon-setting" }),
            _createElementVNode("span", { class: "title" }, "Paramètres")
          ], -1)),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("ul", _hoisted_71, [
                _createElementVNode("li", _hoisted_72, [
                  _createVNode(_component_router_link, {
                    to: "/profile",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => _cache[39] || (_cache[39] = [
                      _createTextVNode(" Profile ", -1)
                    ])),
                    _: 1,
                    __: [39]
                  })
                ]),
                (_ctx.auth.can('SETTINGS'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_73, [
                      _createVNode(_component_router_link, {
                        to: "/account-settings",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => _cache[40] || (_cache[40] = [
                          _createTextVNode(" Général ", -1)
                        ])),
                        _: 1,
                        __: [40]
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.auth.can('SETTINGS'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_74, [
                      _createVNode(_component_router_link, {
                        to: "/zones-settings",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => _cache[41] || (_cache[41] = [
                          _createTextVNode(" Zones ", -1)
                        ])),
                        _: 1,
                        __: [41]
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.auth.can('SETTINGS'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_75, [
                      _createVNode(_component_router_link, {
                        to: "/cities-settings",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => _cache[42] || (_cache[42] = [
                          _createTextVNode(" Villes ", -1)
                        ])),
                        _: 1,
                        __: [42]
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.auth.can('SETTINGS'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_76, [
                      _createVNode(_component_router_link, {
                        to: "/agencies-settings",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => _cache[43] || (_cache[43] = [
                          _createTextVNode(" Agences ", -1)
                        ])),
                        _: 1,
                        __: [43]
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.auth.can('SETTINGS_ADS'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_77, [
                      _createVNode(_component_router_link, {
                        to: "/ads-settings",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => _cache[44] || (_cache[44] = [
                          _createTextVNode(" Annonces ", -1)
                        ])),
                        _: 1,
                        __: [44]
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.auth.can('BLACK_LISTE'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_78, [
                      _createVNode(_component_router_link, {
                        to: "/black-list",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => _cache[45] || (_cache[45] = [
                          _createTextVNode(" Black Liste ", -1)
                        ])),
                        _: 1,
                        __: [45]
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}